import React, { FC } from 'react';
import { RouterProps } from 'react-router';
import { EditablePage } from '@shared/components';
import { ProjectManagementSummary } from './components';

export const ProjectManagementSummaryTab: FC<RouterProps> = () => (
  <EditablePage editableComponent={ProjectManagementSummary} />
);
